import { Component, Host, h, Event, Prop } from '@stencil/core';
export class DialogFooter {
  constructor() {
    /**
     * Defines the label of the dialog-footer submit button
     */
    this.submitLabel = 'Save';
    /**
     * Defines the label of the dialog-footer cancel button
     */
    this.cancelLabel = 'Cancel';
  }
  getButtonAttributes(btnType) {
    const attributes = {
      label: btnType !== 'save' ? this.cancelLabel : this.submitLabel,
      content: 'text-only',
      small: false,
      disabled: false,
      type: btnType !== 'save' ? 'basic' : 'accent',
    };
    return attributes;
  }
  render() {
    return (h(Host, null,
      h("sy-button", Object.assign({}, this.getButtonAttributes('save'), { onClick: () => this.syDialogFooterDidSubmitClick.emit() })),
      h("sy-button", Object.assign({}, this.getButtonAttributes('cancel'), { onClick: () => this.syDialogFooterDidCancelClick.emit() }))));
  }
  static get is() { return "sy-dialog-footer"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() { return {
    "$": ["scss/index.scss", "scss/_tokens.scss"]
  }; }
  static get styleUrls() { return {
    "$": ["./scss/index.css", "./scss/_tokens.css"]
  }; }
  static get properties() { return {
    "submitLabel": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Defines the label of the dialog-footer submit button"
      },
      "attribute": "submit-label",
      "reflect": true,
      "defaultValue": "'Save'"
    },
    "cancelLabel": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Defines the label of the dialog-footer cancel button"
      },
      "attribute": "cancel-label",
      "reflect": true,
      "defaultValue": "'Cancel'"
    }
  }; }
  static get events() { return [{
      "method": "syDialogFooterDidSubmitClick",
      "name": "syDialogFooterDidSubmitClick",
      "bubbles": false,
      "cancelable": false,
      "composed": true,
      "docs": {
        "tags": [],
        "text": "Event to indicate the click on the dialog-footer submit button."
      },
      "complexType": {
        "original": "void",
        "resolved": "void",
        "references": {}
      }
    }, {
      "method": "syDialogFooterDidCancelClick",
      "name": "syDialogFooterDidCancelClick",
      "bubbles": false,
      "cancelable": false,
      "composed": true,
      "docs": {
        "tags": [],
        "text": "Event to indicate the click on the dialog-footer cancel button."
      },
      "complexType": {
        "original": "void",
        "resolved": "void",
        "references": {}
      }
    }]; }
}
